export default "__VITE_ASSET__D6D5Mddd__"